/*
  ADE-HOME: Suche
  1) Vorschlagsuche zusaetzlich nach Artikelnummer (SKU) und EAN durchsuchen.
  2) Zusammengesetzte Woerter (z. B. "Kuechenwaage") exakt suchen: Shopify zerlegt sie sonst in
     "Kuechen" + "Waage" und findet jede Waage und jedes Kuechenprodukt. Beim Absenden des Suchformulars
     werden solche Woerter in Anfuehrungszeichen gesetzt (Logik: window.adeSuche in snippets/ade-head.liquid).
  Eigene Datei statt Aenderung an search.js (update-fest). Geladen ueber snippets/ade-head.liquid.
*/
(function () {
  var FIELDS = 'title,variants.title,variants.sku,variants.barcode';
  var originalFetch = window.fetch;
  if (!originalFetch) return;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && url.indexOf('/search/suggest') !== -1) {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('resources[options][fields]', FIELDS);
        input = typeof input === 'string' ? u.toString() : new Request(u.toString(), input);
      }
    } catch (e) {}
    return originalFetch.call(this, input, init);
  };
})();

(function () {
  var suche = window.adeSuche;
  if (!suche) return;

  // Suchformulare: zusammengesetzte Woerter vor dem Absenden exakt machen
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || !/\/search\/?$/.test(new URL(form.action, location.origin).pathname)) return;
    var feld = form.querySelector('input[name="q"]');
    if (!feld) return;
    // nur Produkte und Ratgeber-Artikel durchsuchen, keine Inhaltsseiten
    if (!form.querySelector('input[name="type"]')) {
      var typ = document.createElement('input');
      typ.type = 'hidden';
      typ.name = 'type';
      typ.value = suche.typen;
      form.appendChild(typ);
    }
    var neu = suche.umschreiben(feld.value);
    if (neu === feld.value) return;
    feld.value = neu;
    var flag = form.querySelector('input[name="ade"]');
    if (!flag) {
      flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'ade';
      form.appendChild(flag);
    }
    flag.value = '1';
  }, true);

  // Ergebnisseite: Anfuehrungszeichen in Suchfeld und Ueberschrift nicht anzeigen
  if (!suche.istErgebnisseite || !suche.original) return;
  function aufraeumen() {
    document.querySelectorAll('input[name="q"]').forEach(function (feld) {
      if (feld.value === suche.begriffe) feld.value = suche.original;
    });
    document.title = document.title.split('"' + suche.original + '"').join(suche.original);
    var main = document.getElementById('MainContent') || document.body;
    var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    var knoten;
    while ((knoten = walker.nextNode())) {
      if (knoten.nodeValue.indexOf(suche.begriffe) !== -1) {
        knoten.nodeValue = knoten.nodeValue.split(suche.begriffe).join(suche.original);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aufraeumen);
  else aufraeumen();
})();
